<script lang="ts">
    /**
     * The labels under an improvement slider that ends at the Estimated Frontier or a little past it: Flexible at its start and
     * Rigid under the frontier, placed as SelectSlider places the thumb (its centre travels from half the thumb's width to
     * the width less that), sliding to stay inside the track at its end.
     */
    export let min: number
    export let max: number
    export let frontier: number
    export let thumbSize = 30

    $: at = max > min ? Math.min(1, Math.max(0, (frontier - min)/(max - min))) : 1
</script>

<!-- Padding, not a margin, which would merge with the track's and leave the thumb over the labels -->
<div class="relative h-6 pt-2 text-xs text-slate-500" aria-hidden="true">
    <span class="absolute left-0">Flexible</span>
    <span class="absolute whitespace-nowrap" style="left: calc({thumbSize/2}px + (100% - {thumbSize}px) * {at}); transform: translateX(-{50 + 50*Math.max(0, at - 0.9)/0.1}%)">Rigid</span>
</div>
